"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const theme_provider_1 = require("../theme-provider");
const character_counter_1 = require("./character-counter");
var TextAreaAppearance;
(function (TextAreaAppearance) {
    TextAreaAppearance[TextAreaAppearance["Default"] = 0] = "Default";
    TextAreaAppearance[TextAreaAppearance["Disabled"] = 1] = "Disabled";
    TextAreaAppearance[TextAreaAppearance["Error"] = 2] = "Error";
    TextAreaAppearance[TextAreaAppearance["ReadOnly"] = 3] = "ReadOnly";
    TextAreaAppearance[TextAreaAppearance["Search"] = 4] = "Search";
})(TextAreaAppearance = exports.TextAreaAppearance || (exports.TextAreaAppearance = {}));
// @todo get from theme
const borderSize = '2px';
// @todo this is essentially the same as StyledLabelText in text-input
const StyledLabelText = theme_provider_1.styled.p.withConfig({ displayName: "StyledLabelText", componentId: "sc-7f24ke" }) `
	font-size: ${({ theme, isFloating }) => isFloating
    ? theme.textAppearances.copy0200.fontSize
    : theme.textAppearances.copy0100.fontSize};
	margin: 0;
	padding: 0;
	position: absolute;
	top: 0;
	${({ theme, isFloating }) => isFloating
    ? theme_provider_1.css `
					transition: all ease-in-out 0.25s;
					transform: translateY(${theme.size.static100})
						translateY(${theme.size.static150})
						translateY(${theme.textAppearances.copy0100.fontSize});
			  `
    : undefined}
`;
const StyledTextArea = theme_provider_1.styled.textarea.withConfig({ displayName: "StyledTextArea", componentId: "sc-1c8x0h3" }) `
	width: 100%;
	border-radius: 0;
	/* MinHeight is calculated via lineHeight and padding of the element. If any value is changed then you have to update it */
	min-height: ${props => `calc(${props.theme.size.static150} * 2 + ${props.theme.textAppearances.copy0200.lineHeight})`};
	background: transparent;
	border: 0;
	color: ${({ theme, appearance }) => appearance === TextAreaAppearance.ReadOnly
    ? theme.interaction.recipe100.default
    : appearance === TextAreaAppearance.Disabled
        ? theme.interaction.recipe500.disabled
        : theme.interaction.recipe500.default};
	cursor: ${({ appearance }) => appearance === TextAreaAppearance.Disabled ? 'not-allowed' : ''};
	padding: ${props => props.theme.size.static150} 0;
	border-bottom: ${({ appearance }) => appearance !== TextAreaAppearance.ReadOnly && `${borderSize} solid`};
	border-color: ${({ theme, appearance }) => appearance === TextAreaAppearance.Error
    ? theme.interaction.recipe360.default
    : appearance === TextAreaAppearance.Disabled
        ? theme.interaction.recipe150.disabled
        : theme.interaction.recipe150.default};
	outline: 0;
	font-size: ${props => props.theme.textAppearances.copy0200.fontSize};
	line-height: ${props => props.theme.textAppearances.copy0200.lineHeight};
	font-family: inherit;
	margin-top: ${props => props.theme.size.static100};

	&:focus {
		border-color: ${({ theme, appearance }) => appearance !== TextAreaAppearance.Error
    ? theme.interaction.recipe150.checked
    : undefined};

		& + div span {
			color: ${props => props.theme.border.color.primary};
		}

		~ ${StyledLabelText} {
			transform: translateY(0);
			font-size: ${props => props.theme.textAppearances.copy100.fontSize};
		}
	}

	${props => props.hasValue &&
    theme_provider_1.css `
			& ~ ${StyledLabelText} {
				transform: translateY(0);
				font-size: ${props.theme.textAppearances.copy100.fontSize};
			}
		`}
`;
// @todo same as StyledLabel in text-input
const StyledLabel = theme_provider_1.styled.label.withConfig({ displayName: "StyledLabel", componentId: "sc-1bo2uck" }) `
	display: block;
	width: 100%;
	position: relative;
	padding-top: ${props => props.theme.size.static250};
	color: ${({ theme, appearance }) => appearance === TextAreaAppearance.ReadOnly
    ? theme.interaction.recipe100.default
    : appearance === TextAreaAppearance.Disabled
        ? theme.interaction.recipe500.disabled
        : appearance === TextAreaAppearance.Search
            ? theme.interaction.recipe400.default
            : theme.interaction.recipe450.default};

	&:focus-within {
		&::after {
			content: '';
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
			width: 100%;
			height: calc(100% + 4px);
			border-width: 2px 0;
			border-color: ${props => props.theme.focusColor};
			border-style: solid;
			pointer-events: none;
		}
	}
`;
// @todo same as StyledLabel in text-input
const StyledAdditionalInfo = theme_provider_1.styled.div.withConfig({ displayName: "StyledAdditionalInfo", componentId: "sc-1t92ml9" }) `
	display: flex;
	flex-direction: row;
	justify-content: ${props => props.errorShouldBeVisible ? 'space-between' : 'flex-end'};
	color: ${({ theme, appearance }) => appearance === TextAreaAppearance.Error
    ? theme.interaction.recipe360.default
    : appearance === TextAreaAppearance.Disabled
        ? theme.interaction.recipe150.disabled
        : theme.interaction.recipe150.default};
`;
// @todo same as StyledLabel in text-input
const StyledErrorText = theme_provider_1.styled.p.withConfig({ displayName: "StyledErrorText", componentId: "sc-12gbrax" }) `
	display: block;
	color: ${props => props.theme.interaction.recipe360.default};
	font-size: ${props => props.theme.textAppearances.copy0100.fontSize};
	margin: 0;
`;
class TextArea extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasValue: false };
        this.validateTextArea = this.validateTextArea.bind(this);
    }
    validateTextArea(event) {
        this.setState({ hasValue: Boolean(event.currentTarget.value) });
    }
    componentDidMount() {
        this.setState({ hasValue: Boolean(this.props.value) });
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.value !== prevProps.value &&
            prevState.hasValue !== Boolean(this.props.value)) {
            this.setState({ hasValue: Boolean(this.props.value) });
        }
    }
    render() {
        const { label, appearance, name, onChange, onBlur, onFocus, value, errorText, placeholder, rows = 1, minLength, maxLength, required, isFloating } = this.props;
        const { hasValue } = this.state;
        const errorShouldBeVisible = Boolean(appearance === TextAreaAppearance.Error && errorText);
        return (React.createElement(StyledLabel, { appearance: appearance },
            React.createElement(StyledTextArea, { readOnly: appearance === TextAreaAppearance.ReadOnly, disabled: appearance === TextAreaAppearance.Disabled, rows: rows, appearance: appearance, minLength: minLength, name: name, onChange: onChange, onBlur: event => {
                    this.validateTextArea(event);
                    if (onBlur) {
                        onBlur(event);
                    }
                }, onFocus: onFocus, placeholder: placeholder, value: value, required: required, hasValue: hasValue }),
            React.createElement(StyledLabelText, { isFloating: isFloating },
                label,
                required && '*'),
            (errorShouldBeVisible || maxLength) && (React.createElement(StyledAdditionalInfo, { errorShouldBeVisible: errorShouldBeVisible, appearance: appearance },
                errorShouldBeVisible && (React.createElement(StyledErrorText, { "aria-live": "assertive", "aria-relevant": "all" }, errorText)),
                maxLength && (React.createElement(character_counter_1.CharacterCounter, { value: value, maxLength: maxLength }))))));
    }
}
exports.TextArea = TextArea;
